import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const HeaderLink = ({ link, title, icon: Icon, extraClasses = '', isMobile = false, onClick }) => {
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
            return;
        }
        // ... existing click handling
    };

    if (isMobile) {
        return (
            <Link
                to={link}
                className="flex items-center gap-3 px-4 py-2 text-gray-700 hover:bg-gray-100 dark:text-neutral-200 dark:hover:bg-neutral-700"
                onClick={handleClick}
            >
                {Icon && <Icon className="text-gray-500" />}
                <span className="text-sm">{title}</span>
            </Link>
        );
    }

    return (
        <Link
            to={link}
            className={`inline-flex justify-center items-center gap-x-2 font-medium text-[12px] text-gray-800 hover:text-neutral-500 focus:outline-none focus:text-neutral-500 dark:text-neutral-200 dark:hover:text-neutral-500 dark:focus:text-neutral-500 ${extraClasses} hidden lg:inline-block`}
            onClick={handleClick}
        >
            {title}
        </Link>
    );
};

HeaderLink.propTypes = {
    link: PropTypes.string,
    title: PropTypes.string.isRequired,
    icon: PropTypes.elementType,
    extraClasses: PropTypes.string,
    isMobile: PropTypes.bool,
    onClick: PropTypes.func
};

export default HeaderLink;